import React from 'react';
import './testResult.scss';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';


export default function Stepper({ type, goBack, goNext, myTest }) {
    const navigate = useNavigate();
    const location = useLocation();
    const { selectedTests, testDetails } = useSelector(state => state.testLibrary);

    const testId = location.state?.testId || localStorage.getItem('testId');
    const jobId = testDetails?.jobId;

    const goToStep = async (step) => {
        if (!testId) return;

        if ((step === 2 || step === 3) && selectedTests?.length === 0) {
            return;
        }

        if (step === 3 && jobId) return;
        if ((type === 'test' || type === 'add-question') && goNext && typeof goNext === 'function') {
             let currentStep = type === 'test' ? 1 : 2;
             if (step !== currentStep) {
                 const success = await goNext(false); 
                 if (!success) return; 
             }
        }

        if (step === 1) {
            navigate('/home/select-test', { state: { testId } });
        } else if (step === 2) {
            navigate('/home/add-question', { state: { testId, isQuestionVisible: false } });
        } else if (step === 3) {
            navigate('/home/invite-preview', { state: { testId, myTest: false } });
        }
    }

    return (
        <div className=''>
            {
                window.innerWidth > 767 ?
                    <div className='stepper-header'>
                        <div className="stepper-container">
                            {/* <div className='d-flex align-items-center'>
                                <img src='/images/back.svg' onClick={goBack} alt='' width={20} className='cursor-pointer' />
                                <div className='back'>
                                    Back To<br /> {type === 'preview' ? 'Add Question' : type === 'add-question' ? 'Select tests' : 'Library'}
                                </div>
                            </div> */}
                            <div className={type === 'test' ? "stepper-step active d-flex gap-2" : "stepper-step d-flex gap-2"} onClick={() => goToStep(1)} style={{ cursor: testId ? 'pointer' : 'not-allowed' }}>
                                <span className="step-label">
                                    <button>1</button>&nbsp;
                                    &nbsp;Select Test
                                </span>
                            </div>
                            <img src='/images/double-arrow-right.svg' alt='' />
                            <div className={type === 'add-question' ? "stepper-step active" : "stepper-step"} onClick={() => goToStep(2)} style={{ cursor: (testId && selectedTests?.length > 0) ? 'pointer' : 'not-allowed' }}>
                                <span className="step-label">
                                    <button>2</button>&nbsp;
                                    &nbsp;Add more questions
                                </span>
                            </div>
                            <img src='/images/double-arrow-right.svg' alt='' />
                            <div className={type === 'preview' ? "stepper-step active" : "stepper-step"} onClick={() => goToStep(3)} style={{ cursor: (testId && selectedTests?.length > 0 && !jobId) ? 'pointer' : 'not-allowed' }}>
                                <span className="step-label">
                                    <button>3</button>&nbsp;
                                    &nbsp;Preview & Invite
                                </span>
                            </div>
                        </div>
                        {/* {type === 'preview' ? null : <div className='ms-5'>
                            <button className='next-btn' onClick={goNext}>Next</button>
                        </div>} */}
                    </div> :
                    <div className='gappeo-mobile-header1'>
                        <div className='selected-header d-flex justify-content-between'>
                            <div className='d-flex align-items-center'>
                                <img src='/images/back.svg' alt='' width={15} onClick={goBack} />&nbsp;&nbsp;
                                <div>
                                    <div className='d-flex align-items-center'>
                                        <div className={type === 'test' ? 'circle active' : 'circle'} onClick={() => goToStep(1)} style={{ cursor: testId ? 'pointer' : 'not-allowed' }}></div>&nbsp;
                                        <div className={type === 'add-question' ? 'circle active' : 'circle'} onClick={() => goToStep(2)} style={{ cursor: (testId && selectedTests?.length > 0) ? 'pointer' : 'not-allowed' }}></div>&nbsp;
                                        <div className={type === 'preview' ? 'circle active' : 'circle'} onClick={() => goToStep(3)} style={{ cursor: (testId && selectedTests?.length > 0 && !jobId) ? 'pointer' : 'not-allowed' }}></div>
                                    </div>
                                    <h3 className='mt-2'>{type === 'test' ? 'Select Tests' : type === 'add-question' ? 'Add Question' : 'Preview & Invite'}</h3>
                                </div>
                            </div>
                            <button className='outline-btn' onClick={goNext}>Next</button>
                        </div>
                    </div>
            }
        </div>
    )
}
